import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import Select, { components } from "react-select";
import { ApexOptions } from "apexcharts";
import ApexCharts from "apexcharts";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./active-users.scss";
import ReactApexChart from "react-apexcharts";
import {
  leadStatusesName,
  leadStatusesNameColors,
} from "../lead-source-breakdown/lead-source-breakdown.constant";

interface ActiveUsersProps {
  series: any[];
  title?: string;
  loading?: boolean;
  seriesCount?: any[];
  handleAddLeadReports: (data: any, params: any) => void;
  enableExport?: boolean;
}
const ActiveUsers: React.FC<ActiveUsersProps> = ({
  series,
  title,
  handleAddLeadReports,
  loading = false,
  seriesCount = [],
  enableExport = false,
}) => {
  const [fileFormat, setFileFormat] = useState<any>({
    value: "pdf",
    label: "PDF",
  });

  const activeUsers: ApexOptions = {
    chart: {
      type: "donut" as const,
      id: "status-attribution",
      toolbar: {
        show: false,
        tools: {
          download: true,
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
        },
      },
    },
    responsive: [
      {
        options: {
          chart: {
            width: "100%",
          },
        },
      },
      {
        breakpoint: 1024,
        options: {
          legend: {
            position: "bottom",
            horizontalAlign: "left",
            with: "100%",
          },
        },
      },
    ],
    labels: leadStatusesName,
    dataLabels: {
      enabled: false,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
    legend: {
      horizontalAlign: "left",
      fontSize: "14px",
      position: "right",
      formatter: function (val, opts) {
        return val + " - " + opts.w.globals.series[opts.seriesIndex] + "%";
      },
      floating: false,

      itemMargin: {
        horizontal: 10,
        vertical: 6,
      },
      markers: {
        size: 5,
        strokeWidth: 0,
        offsetX: -5,
      },
      width: 220,
    },

    tooltip: {
      enabled: true,
      y: {
        formatter: (value) => `${value}% <span>No. Of leads: ${value}</span>`,
      },
    },
    colors: leadStatusesNameColors,
    states: {
      hover: {
        filter: {
          type: "none", // disables hover color filter
        },
      },
      active: {
        filter: {
          type: "none", // disables active state color filter too
        },
      },
    },
  };

  const handleExport = async () => {
    try {
      const response = await ApexCharts.exec("status-attribution", "dataURI");
      handleAddLeadReports(
        { imageData: response?.imgURI.split(",")[1] },
        { section: "status-attribution", format: fileFormat.value }
      );
    } catch (error) {
      console.error("Error getting base64:", error);
    }
  };

  return (
    <div className="active-users-wrapper">
      <Box
        sx={{
          padding: "10px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        className="active-users-header"
      >
        <p className="header-text">{title}</p>
        <Box sx={{ display: "flex", gap: 1 }} className="export-wrapper">
          <Select
            options={[
              { value: "pdf", label: "PDF" },
              { value: "csv", label: "CSV" },
            ]}
            onChange={(e: any) => setFileFormat(e)}
            value={fileFormat}
            isSearchable={false}
            className="select-dropdown"
            components={{
              DropdownIndicator: (props) => {
                return (
                  <components.DropdownIndicator {...props}>
                    <ArrowDropDownIcon
                      style={{ fontSize: 20, color: "black" }}
                    />
                  </components.DropdownIndicator>
                );
              },
              IndicatorSeparator: () => null,
            }}
          />
          <Button
            variant="outlined"
            onClick={handleExport}
            className="address-edit-button"
            disabled={!enableExport}
          >
            Export
          </Button>
        </Box>
      </Box>
      <Box sx={{ padding: "0 20px" }}>
        {series?.length > 0 && !loading ? (
          <ReactApexChart
            options={{
              ...activeUsers,
              tooltip: {
                enabled: true,
                y: {
                  formatter: (value, index) => {
                    return `${value}% <span>No. Of leads: ${seriesCount[index?.dataPointIndex || 0]}</span>`;
                  },
                },
              },
            }}
            series={
              series?.sort(
                (attributionOne: any, attributionTwo: any) =>
                  attributionTwo - attributionOne
              ) || []
            }
            type="donut"
            height={250}
          />
        ) : (
          <Box className="lead-conversion-trend-wrapper">
            <Box>
              <Box sx={{ position: "relative" }}> No data available </Box>
            </Box>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default ActiveUsers;
